import { StyledSpinner, SpinnerWrapper} from "./styled";

export const Loading = () => (
  <SpinnerWrapper>
    <StyledSpinner />
  </SpinnerWrapper>
);

export default Loading;
